import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcAttachIcon } from '@gem/icons';
import { FAB } from '@gem/ui-kit';

import { useAttachmentsButtonPresenter } from './AttachmentsButton.presenter';
import { AttachmentsButtonMenu } from './AttachmentsButtonMenu/AttachmentsButtonMenu';
import FileUploadButton from './FileUploadButton';
import FirstArticleOnboarding from './FirstArticleOnboarding';

export const AttachmentsButton: FC = observer(() => {
  const { presenter, attachmentsButtonRef, fileUploadRef } = useAttachmentsButtonPresenter();

  return (
    <div>
      <FileUploadButton
        onSelectFile={presenter.uploadFile}
        ref={fileUploadRef}
      />
      <FAB
        size={'30'}
        onClick={presenter.toggleMenu}
        dataTest="attach-button"
        Icon={IcAttachIcon}
        theme={presenter.isMenuOpen ? '8_1' : '8'}
        setRef={attachmentsButtonRef}
      />
      <AttachmentsButtonMenu
        isOpened={presenter.isMenuOpen}
        fileUploadRef={fileUploadRef}
        attachButtonRef={attachmentsButtonRef}
        onClose={presenter.closeMenu}
      />
      {presenter.isShowOnboarding && <FirstArticleOnboarding reference={attachmentsButtonRef} />}
    </div>
  );
});
